module.exports = __webpack_public_path__ + "img/coupon-mockup-1.6f23bc53.png";